/* IMMT theme behaviour — small, dependency-free. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Header height (for sticky offsets) ---------- */
  const group = $('#header-group');
  const util = $('.hd__util');
  const setHeights = () => {
    if (!group) return;
    const u = util && getComputedStyle(util).display !== 'none' ? util.offsetHeight : 0;
    document.documentElement.style.setProperty('--util-h', `${u}px`);
    document.documentElement.style.setProperty('--hd-h', `${group.offsetHeight - u}px`);
  };
  setHeights();
  window.addEventListener('resize', setHeights);
  if (group && 'ResizeObserver' in window) new ResizeObserver(setHeights).observe(group);

  /* ---------- Geo prompt (immt.pl <-> immt.lt) ---------- */
  const geo = $('[data-geo]');
  if (geo && !/bot|crawl|spider|slurp|lighthouse|pagespeed/i.test(navigator.userAgent)) {
    const site = geo.dataset.site; // 'pl' | 'lt'
    const KEY = 'immt_geo_choice';
    const TTL = 1000 * 60 * 60 * 24 * 30;
    const store = (v) => { try { localStorage.setItem(KEY, JSON.stringify({ v, t: Date.now() })); } catch (_) {} };
    const stored = () => {
      try {
        const j = JSON.parse(localStorage.getItem(KEY) || 'null');
        return j && Date.now() - j.t < TTL ? j.v : null;
      } catch (_) { return null; }
    };
    const closeGeo = () => {
      if (geo.open) { try { geo.close(); } catch (_) {} }
      geo.removeAttribute('open');
      document.documentElement.classList.remove('is-locked');
    };
    const openGeo = (copy) => {
      $$('[data-geo-copy]', geo).forEach((p) => { p.hidden = p.dataset.geoCopy !== copy; });
      const target = copy === 'pl' ? 'https://www.immt.pl' : 'https://www.immt.lt';
      $$('[data-geo-go]', geo).forEach((a) => { a.href = target + location.pathname + location.search + location.hash; });
      if (typeof geo.showModal === 'function') { try { geo.showModal(); } catch (_) { geo.setAttribute('open', ''); } }
      else geo.setAttribute('open', '');
      document.documentElement.classList.add('is-locked');
    };
    geo.addEventListener('click', (e) => {
      if (e.target.closest('[data-geo-stay]')) { store('stay'); closeGeo(); }
      else if (e.target.closest('[data-geo-go]')) { store('go'); }
    });
    geo.addEventListener('cancel', (e) => { e.preventDefault(); store('stay'); closeGeo(); });

    const decide = (country) => {
      const c = (country || '').toUpperCase();
      if (!c) return;
      if (site === 'lt' && c === 'PL') openGeo('pl');
      else if (site === 'pl' && c !== 'PL') openGeo(c === 'LT' ? 'lt' : 'en');
    };
    if (!stored() && !new URLSearchParams(location.search).has('nogeo')) {
      fetch(`${root}browsing_context_suggestions.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((j) => {
          const c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          if (c) decide(c);
          else {
            const lang = (navigator.language || '').slice(0, 2).toLowerCase();
            decide(lang === 'pl' ? 'PL' : lang === 'lt' ? 'LT' : '');
          }
        })
        .catch(() => {});
    }
  }

  /* ---------- Drawer ---------- */
  const drawer = $('#immt-drawer');
  const canModal = drawer && typeof drawer.showModal === 'function';
  const openDrawer = () => {
    if (!drawer) return;
    if (canModal) { try { drawer.showModal(); } catch (_) { drawer.setAttribute('open', ''); } }
    else drawer.setAttribute('open', '');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
  };
  const closeDrawer = () => {
    if (!drawer) return;
    if (canModal && drawer.open) { try { drawer.close(); } catch (_) {} }
    drawer.removeAttribute('open');
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === drawer) closeDrawer();
  });
  drawer?.addEventListener('close', closeDrawer);
  drawer?.addEventListener('cancel', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer(); });

  /* ---------- Mobile search toggle ---------- */
  const hd = $('[data-immt-header]');
  $('[data-search-toggle]')?.addEventListener('click', () => {
    hd.classList.toggle('is-searching');
    if (hd.classList.contains('is-searching')) $('#immt-q')?.focus();
  });

  /* ---------- Predictive search ---------- */
  const form = $('[data-predictive]');
  if (form) {
    const input = $('input[type="search"]', form);
    const box = $('.hd__suggest', form);
    let timer, ctrl, active = -1;
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const close = () => { box.hidden = true; active = -1; input.setAttribute('aria-expanded', 'false'); };
    // Format like Liquid's money filter, using a server-rendered sample (1234567.89)
    const sample = form.dataset.moneySample || '';
    const m = sample.match(/1(\D?)234(\D?)567(\D)89/);
    const money = (value) => {
      const n = Number(value);
      if (!m) return n.toFixed(2);
      const [int, dec] = n.toFixed(2).split('.');
      const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
      return sample.replace(/1\D?234\D?567\D89/, grouped + m[3] + dec);
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) return close();
      timer = setTimeout(async () => {
        ctrl?.abort();
        ctrl = new AbortController();
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor,tag`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const hidePL = document.documentElement.dataset.noShining === '1';
          const items = (data?.resources?.results?.products || []).filter((p) => !(hidePL && (p.tags || []).includes('Marka: SHINING 3D')));
          const allHref = `${form.action}?q=${encodeURIComponent(q)}&type=product&options[prefix]=last`;
          const cols = (data?.resources?.results?.collections || []).filter((c) => !/^(test|pagrindinis-puslapis|zenklas-bioclear|all)$/.test(c.handle)).slice(0, 3);
          const colHtml = cols.length ? `<ul class="sg__cols">${cols.map((c) => `<li class="sg__item sg__item--col"><a href="${esc(c.url)}" role="option"><span class="sg__cat">${esc(form.dataset.catLabel || 'Kategorija')}</span><span class="sg__title">${esc(c.title)}</span></a></li>`).join('')}</ul>` : '';
          if (!items.length && !cols.length) {
            box.innerHTML = `<p class="sg__empty">${esc(form.dataset.empty || '—')}</p>`;
            if (hidePL && (data?.resources?.results?.products || []).length) { box.hidden = true; return; }
          } else {
            box.innerHTML = colHtml + `<ul>${items.map((p) => `
              <li class="sg__item"><a href="${esc(p.url)}" role="option">
                <span class="sg__img">${(() => { const src = p.image || p.featured_image?.url; if (!src) return ''; return `<img src="${esc(src + (src.includes('?') ? '&' : '?') + 'width=120')}" alt="" loading="lazy">`; })()}</span>
                <span class="sg__title">${esc(p.title)}</span>
                <span class="sg__price">${(p.tags || []).includes('request_price') || !(Number(p.price) > 0) ? esc(form.dataset.rqLabel || 'Kaina pagal užklausą') : esc(money(Number(p.price)))}</span>
              </a></li>`).join('')}</ul><a class="sg__all" href="${esc(allHref)}">${esc(form.querySelector('button')?.getAttribute('aria-label') || 'Search')} →</a>`;
          }
          box.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } catch (_) { /* aborted */ }
      }, 180);
    });
    input.addEventListener('keydown', (e) => {
      const links = $$('.sg__item a', box);
      if (box.hidden || !links.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach((l, i) => l.setAttribute('aria-selected', i === active ? 'true' : 'false'));
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        location.href = links[active].href;
      } else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = Number(input.min || 0);
    input.value = Math.max(min, (Number(input.value) || 0) + Number(b.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Auto-submit (filters, sorting, cart qty) ---------- */
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-autosubmit]');
    if (!el) return;
    const f = el.form;
    if (!f) return;
    if (f.matches('[data-cart-form]')) {
      clearTimeout(f._t);
      f._t = setTimeout(() => { const h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1'; f.appendChild(h); f.submit(); }, 500);
    } else if (f.closest('[data-collection]')) {
      const params = new URLSearchParams(new FormData(f));
      for (const [k, v] of [...params]) if (v === '') params.delete(k);
      renderCollection(`${f.action.split('?')[0]}?${params.toString()}`);
    } else {
      f.submit();
    }
  });

  /* ---------- Mobile filters ---------- */
  const setFilters = (open) => {
    const panel = $('[data-filters]');
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('is-locked', open);
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-filters-open]')) setFilters(true);
    else if (e.target.closest('[data-filters-close]')) setFilters(false);
  });

  let collCtrl;
  async function renderCollection(url, push = true) {
    const coll = $('[data-collection]');
    if (!coll) { location.href = url; return; }
    const main = $('.coll__main', coll);
    main?.classList.add('is-loading');
    const wasOpen = $('[data-filters]', coll)?.classList.contains('is-open');
    const openDetails = $$('.filter', coll).map((d) => d.open);
    collCtrl?.abort();
    collCtrl = new AbortController();
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', coll.dataset.sectionId);
      const html = await (await fetch(u, { signal: collCtrl.signal })).text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-collection]');
      if (!next) throw new Error('no section');
      coll.innerHTML = next.innerHTML;
      document.dispatchEvent(new CustomEvent('immt:cards'));
      $$('.filter', coll).forEach((d, i) => { if (openDetails[i] !== undefined) d.open = openDetails[i]; });
      if (wasOpen) $('[data-filters]', coll)?.classList.add('is-open');
      if (push) history.pushState({ immtColl: true }, '', url);
    } catch (err) {
      if (err.name !== 'AbortError') location.href = url;
    }
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-collection] .pager a, [data-collection] .filters__clear, [data-collection] .empty a');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    renderCollection(a.href);
    if (a.closest('.pager')) $('[data-collection]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  window.addEventListener('popstate', () => { if ($('[data-collection]')) renderCollection(location.href, false); });

  /* ---------- Product page ---------- */
  const pp = $('[data-product]');
  if (pp) {
    // Gallery
    const show = (id) => {
      $$('.pp__slide', pp).forEach((s) => {
        const on = s.dataset.mediaId === String(id);
        s.hidden = !on;
        s.classList.toggle('is-active', on);
        if (!on) s.querySelector('video')?.pause();
      });
      $$('.pp__thumb', pp).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    $$('.pp__thumb', pp).forEach((t) => t.addEventListener('click', () => show(t.dataset.thumb)));

    // Variants
    const vjson = $('[data-variants]', pp);
    const pform = $('[data-product-form]', pp);
    if (vjson && pform) {
      const variants = JSON.parse(vjson.textContent);
      const idInput = $('[data-variant-id]', pform);
      const atc = $('[data-atc]', pform);
      const fieldsets = $$('.opt', pform);
      const selected = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
      const markAvailability = () => {
        const sel = selected();
        fieldsets.forEach((fs, i) => {
          $$('.opt__value', fs).forEach((lab) => {
            const val = lab.querySelector('input').value;
            const probe = sel.slice(); probe[i] = val;
            const v = variants.find((x) => x.options.every((o, k) => o === probe[k]));
            lab.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      };
      // Sparse option matrices (e.g. shade × diameter × thickness): when the chosen combination does not exist,
      // keep the option the user just changed and move the others to the closest existing variant.
      const closest = (sel, fixed) => {
        let best = null, score = -1;
        variants.forEach((x) => {
          if (fixed != null && x.options[fixed] !== sel[fixed]) return;
          const s = x.options.reduce((a, o, k) => a + (o === sel[k] ? (fieldsets.length - k) : 0), 0) + (x.available ? 0.5 : 0);
          if (s > score) { score = s; best = x; }
        });
        return best;
      };
      const update = (e) => {
        let sel = selected();
        let v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        if (!v && e) {
          const fixed = fieldsets.indexOf(e.currentTarget);
          v = closest(sel, fixed >= 0 ? fixed : null);
          if (v) {
            fieldsets.forEach((fs, i) => { const r = $$('input', fs).find((inp) => inp.value === v.options[i]); if (r) r.checked = true; });
            sel = selected();
          }
        }
        markAvailability();
        if (!v) {
          atc.disabled = true; atc.textContent = atc.dataset.unavailable; return;
        }
        idInput.value = v.id;
        atc.disabled = !v.available;
        atc.textContent = v.available ? atc.dataset.label : atc.dataset.unavailable;
        const price = $('[data-price-value]', pp); if (price) price.textContent = v.price;
        const bbp = $('[data-buybar-price]', pp); if (bbp) bbp.textContent = v.price;
        const cmp = $('[data-compare-value]', pp); if (cmp) { cmp.hidden = !v.compare; cmp.textContent = v.compare || ''; }
        const off = $('[data-off-value]', pp); if (off) { off.hidden = !v.off; off.textContent = v.off ? `−${v.off} %` : ''; }
        const sku = $('[data-sku]', pp); if (sku) { sku.hidden = !v.sku; $('[data-sku-value]', sku).textContent = v.sku || ''; }
        const stock = $('[data-stock]', pp);
        if (stock) {
          stock.querySelector('.dot').className = `dot ${v.available ? 'dot--ok' : 'dot--off'}`;
        }
        if (v.media) show(v.media);
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      };
      fieldsets.forEach((fs) => fs.addEventListener('change', update));
      markAvailability();
    }

    // Add to cart (AJAX)
    if (pform) {
      const toast = $('[data-toast]', pp);
      const msg = $('[data-form-msg]', pp);
      pform.addEventListener('submit', async (e) => {
        e.preventDefault();
        const atc = $('[data-atc]', pform);
        if (atc.disabled) return;
        atc.disabled = true;
        const label = atc.textContent;
        atc.textContent = atc.dataset.adding;
        msg.hidden = true;
        try {
          const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(pform) });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          const cart = await (await fetch(`${root}cart.js`)).json();
          $$('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
          if (toast) { toast.hidden = false; clearTimeout(toast._t); toast._t = setTimeout(() => { toast.hidden = true; }, 5000); }
        } catch (err) {
          msg.textContent = err.message; msg.hidden = false;
        } finally {
          atc.disabled = false; atc.textContent = label;
        }
      });
    }

    // Request a quote
    const dlg = $('[data-rq]', pp);
    $$('[data-rq-open]', pp).forEach((b) => b.addEventListener('click', () => { if (!dlg) return; const ti = dlg.querySelector('[data-rq-topic-input]'); if (ti) ti.value = b.dataset.rqTopic || ''; const h = dlg.querySelector('.rq__title'); if (h) { if (!h.dataset.orig) h.dataset.orig = h.textContent; h.textContent = b.dataset.rqHeading || h.dataset.orig; } if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); }));
    dlg?.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    const rq = $('[data-rq-form]', pp);
    if (rq) {
      const out = $('[data-rq-msg]', rq);
      const tpl = (n) => rq.querySelector(`template[data-rq-${n}]`)?.innerHTML.trim();
      rq.addEventListener('submit', async (e) => {
        e.preventDefault();
        const name = rq.querySelector('[name="contact[name]"]').value.trim();
        const email = rq.querySelector('[name="contact[email]"]').value.trim();
        if (!name || !/.+@.+\..+/.test(email)) { out.textContent = tpl('err'); out.className = 'rq__msg is-err'; out.hidden = false; return; }
        const btn = rq.querySelector('[type="submit"]');
        const label = btn.textContent;
        btn.disabled = true; btn.textContent = btn.dataset.sending;
        try {
          const res = await fetch(rq.action, { method: 'POST', body: new FormData(rq), headers: { Accept: 'text/html' } });
          if (res.url.includes('/challenge')) { rq.submit(); return; }
          if (!res.ok) throw new Error();
          out.textContent = tpl('ok'); out.className = 'rq__msg is-ok'; out.hidden = false;
          rq.reset();
        } catch (_) {
          out.textContent = tpl('fail'); out.className = 'rq__msg is-err'; out.hidden = false;
        } finally {
          btn.disabled = false; btn.textContent = label;
        }
      });
    }
  }

  /* ---------- Product sub-navigation highlight ---------- */
  const sublinks = $$('.subnav a[href^="#"]').filter((a) => a.getAttribute('href').length > 1 && !a.classList.contains('subnav__top'));
  if (sublinks.length && 'IntersectionObserver' in window) {
    const map = new Map(sublinks.map((a) => [a.getAttribute('href').slice(1), a]));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          sublinks.forEach((a) => a.classList.remove('is-current'));
          map.get(en.target.id)?.classList.add('is-current');
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    map.forEach((_, id) => { const t = document.getElementById(id); if (t) io.observe(t); });
  }
})();

/* ================= v3 behaviour ================= */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const pad = (n) => String(n).padStart(2, '0');

  /* Soft image reveal (only for images still loading) */
  $$('.pc__media img, .cat__media img, .slide__media img, .spot__media img, .pp__slide img').forEach((img) => {
    if (img.complete && img.naturalWidth) return;
    img.classList.add('lazy-fade');
    const done = () => img.classList.add('is-loaded');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });

  /* Swipe helper */
  const onSwipe = (el, left, right) => {
    let x0 = null, y0 = null;
    el.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; });
    el.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) (dx < 0 ? left : right)();
    });
  };

  /* Hero product slider */
  $$('[data-slider]').forEach((root) => {
    const track = $('[data-track]', root);
    const slides = $$('[data-slide]', root);
    if (slides.length < 2) { slides[0]?.classList.add('is-active'); return; }
    let i = 0, timer = null;
    const cur = $('[data-current]', root);
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.tabIndex = on ? 0 : -1;
        if (on) s.querySelector('img[loading="lazy"]')?.setAttribute('loading', 'eager');
      });
      if (cur) cur.textContent = pad(i + 1);
      // warm up the next image
      slides[(i + 1) % slides.length].querySelector('img[loading="lazy"]')?.setAttribute('loading', 'eager');
    };
    const play = () => { stop(); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => go(i + 1), 6000); };
    const stop = () => { clearInterval(timer); timer = null; };
    $('[data-next]', root)?.addEventListener('click', () => { go(i + 1); play(); });
    $('[data-prev]', root)?.addEventListener('click', () => { go(i - 1); play(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    onSwipe(track, () => { go(i + 1); play(); }, () => { go(i - 1); play(); });
    go(0);
    track.classList.add('is-ready');
    play();
  });

  /* Audience hub: filter cards in place by collection */
  $$('[data-hub-filters]').forEach((bar) => {
    const panel = bar.closest('.hub__panel');
    const items = $$('[data-hub-item]', panel);
    const open = $('[data-hub-open]', bar);
    const none = $('[data-hub-none]', panel);
    $$('[data-hub-filter]', bar).forEach((btn) => btn.addEventListener('click', () => {
      const h = btn.dataset.hubFilter;
      $$('[data-hub-filter]', bar).forEach((b) => { const on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      let n = 0;
      items.forEach((li) => { const on = !h || (' ' + li.dataset.cols + ' ').includes(' ' + h + ' '); li.hidden = !on; if (on) n++; });
      if (none) none.hidden = n > 0;
      if (open) { if (h) { open.href = btn.dataset.hubUrl; open.hidden = false; } else open.hidden = true; }
    }));
  });

  /* Tabs */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    const select = (t, focus) => {
      tabs.forEach((x) => {
        const on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        const p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    if (location.hash) { const h = tabs.find((x) => '#' + x.getAttribute('aria-controls').replace(/^panel-/, '') === location.hash); if (h) select(h); }
    tabs.forEach((t, k) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(k + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(k - 1 + tabs.length) % tabs.length], true); }
      });
    });
  });

  /* Card image swap: only enable once the second image has actually loaded (avoids fading to a blank tile). */
  const armSwap = (img) => {
    const card = img.closest('.pc--swap');
    if (!card) return;
    if (img.complete && img.naturalWidth > 0) card.classList.add('has-alt');
    else img.addEventListener('load', () => card.classList.add('has-alt'), { once: true });
  };
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const armAll = () => $$('.pc__img--alt').forEach(armSwap);
    armAll();
    document.addEventListener('immt:cards', armAll);
  }

  /* Product carousels */
  $$('[data-carousel]').forEach((root) => {
    const track = $('[data-car-track]', root);
    if (!track) return;
    const prev = $('[data-car-prev]', root);
    const next = $('[data-car-next]', root);
    const step = () => (track.querySelector('.car__item')?.offsetWidth || 300) * Math.max(1, Math.floor(track.clientWidth / (track.querySelector('.car__item')?.offsetWidth || 300)));
    const sync = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    sync();
  });

  /* Product gallery arrows, counter, swipe, preload */
  const gal = $('[data-gallery]');
  if (gal) {
    const slides = $$('.pp__slide', gal);
    const thumbs = $$('.pp__thumb', gal);
    const cur = $('[data-g-current]', gal);
    const idx = () => Math.max(0, slides.findIndex((s) => !s.hidden));
    const show = (n) => {
      const k = (n + slides.length) % slides.length;
      slides.forEach((s, j) => {
        const on = j === k;
        s.hidden = !on;
        s.classList.toggle('is-active', on);
        if (!on) s.querySelector('video')?.pause();
      });
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === k));
      if (cur) cur.textContent = k + 1;
    };
    // Keep counter in sync when thumbnails or variants switch media
    new MutationObserver(() => { if (cur) cur.textContent = idx() + 1; }).observe($('.pp__stage', gal), { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    $('[data-g-next]', gal)?.addEventListener('click', () => show(idx() + 1));
    $('[data-g-prev]', gal)?.addEventListener('click', () => show(idx() - 1));
    if (slides.length > 1) onSwipe($('.pp__stage', gal), () => show(idx() + 1), () => show(idx() - 1));
    // Preload the rest of the gallery once the page is idle, so switching is instant
    const warm = () => $$('.pp__slide img[loading="lazy"]', gal).forEach((img) => img.setAttribute('loading', 'eager'));
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1500);
  }
})();

/* ================= v4: mobile buy bar ================= */
(() => {
  const bar = document.querySelector('[data-buybar]');
  const buy = document.querySelector('.pp__buy');
  if (!bar || !buy || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([e]) => {
    const show = !e.isIntersecting && e.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.querySelectorAll('button').forEach((b) => { b.tabIndex = show ? 0 : -1; });
  }).observe(buy);
  bar.querySelector('[data-buybar-atc]')?.addEventListener('click', () => {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
  });
})();

/* v5: footer accordions collapsed on phones, always open on larger screens */
(() => {
  const accs = document.querySelectorAll('[data-ft-acc]');
  if (!accs.length) return;
  const mq = matchMedia('(max-width: 749px)');
  const sync = () => accs.forEach((d) => { d.open = !mq.matches; });
  sync();
  mq.addEventListener?.('change', sync);
})();

/* v6: hide buy bar when the footer (or the main buy box) is on screen */
(() => {
  const bar = document.querySelector('[data-buybar]');
  const footer = document.querySelector('.ft');
  if (!bar || !footer || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([e]) => {
    bar.classList.toggle('is-hidden-footer', e.isIntersecting);
  }, { rootMargin: '0px 0px 40px 0px' }).observe(footer);
  if (matchMedia('(max-width: 989px)').matches) document.body.classList.add('has-buybar');
})();

/* Autoplay videos only while visible (saves several MB on equipment pages) */
(() => {
  const vids = document.querySelectorAll('[data-lazy-video] video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => entries.forEach((e) => {
    const v = e.target;
    if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); } else v.pause();
  }), { rootMargin: '200px 0px' });
  vids.forEach((v) => { v.muted = true; io.observe(v); });
})();

/* Quick add from product cards (single-variant products) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true; b.textContent = b.dataset.adding;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.quickAdd), quantity: 1 }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Error'); return d; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); });
        b.textContent = b.dataset.added; b.classList.add('is-added');
        setTimeout(function () { b.textContent = b.dataset.label; b.classList.remove('is-added'); b.disabled = false; }, 2200);
      })
      .catch(function () { b.textContent = b.dataset.label; b.disabled = false; });
  });
})();

/* Subscription trial option (Appstle selling plan): one-time vs. 30-day trial (20 pcs, -40 %) on the product page */
(() => {
  const TRIAL_QTY = 20;
  const box = document.querySelector('[data-buyopt]');
  if (!box) return;
  const form = box.closest('form');
  const pp = box.closest('.pp') || document;
  const plan = box.querySelector('[data-selling-plan]');
  const trialRadio = box.querySelector('input[value="trial"]');
  const qtyWrap = form.querySelector('.qty');
  const qty = form.querySelector('input[name="quantity"]');
  const idInput = form.querySelector('[data-variant-id]');
  const vjson = document.querySelector('[data-variants]');
  const variants = vjson ? JSON.parse(vjson.textContent) : [];
  const set = (sel, text, root) => { const el = (root || pp).querySelector(sel); if (el && text != null) el.textContent = text; return el; };
  const sync = () => {
    const trial = trialRadio.checked;
    plan.disabled = !trial;
    plan.value = trial ? plan.dataset.planId : '';
    if (qtyWrap) qtyWrap.hidden = trial;
    if (trial && qty) qty.value = TRIAL_QTY;
    box.querySelectorAll('.buyopt__row').forEach((r) => r.classList.toggle('is-on', r.querySelector('input').checked));
    const v = variants.find((x) => String(x.id) === String(idInput.value));
    if (!v) return;
    set('[data-once-price]', v.price, box);
    set('[data-trial-price]', v.trial || v.price, box);
    set('[data-trial-compare]', v.price20 || v.price, box);
    const showTrial = trial && v.trial;
    set('[data-price-value]', showTrial ? v.trial : v.price);
    set('[data-buybar-price]', showTrial ? v.trial : v.price);
    const cmp = pp.querySelector('[data-compare-value]');
    if (cmp) { cmp.hidden = showTrial ? false : !v.compare; cmp.textContent = showTrial ? (v.price20 || v.price) : (v.compare || ''); }
    const off = pp.querySelector('[data-off-value]');
    if (off) { off.hidden = showTrial ? false : !v.off; off.textContent = showTrial ? '−40 %' : (v.off ? `−${v.off} %` : ''); }
  };
  form.addEventListener('change', () => setTimeout(sync, 0));
  const q = new URLSearchParams(location.search).get('plan');
  if (q === 'bandymas' || q === 'trial' || q === 'test') trialRadio.checked = true;
  sync();
})();
